import { Component } from "@angular/core";
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'simple-dialog',
    templateUrl: 'simple-dialog.component.html',
    standalone: false
})
export class SimpleDialogComponent {

    constructor(public dialogRef: MatDialogRef<SimpleDialogComponent>) { }

    public title: string;
    public message: string;
    public cancelLabel: string;
    public actionLabel: string;
    public showCancelButton: boolean;
}
